import { experienceEvent } from '@/events/builders'
import type { EventTuple } from '@/events/types'
import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'
import type { PageEventHandler } from '@/play/pageTypes'
import { letterIndex, sandLettersWorldCells } from './world'

/** Every sand voxel in the tray is loose sand: dug walls slide in. */
export const SAND_LETTERS_KIND = liquidKind('sand', { defaultColor: 0xe8d4a3 })

/** The slide into a trench after a dig, folded into the dig's own undo step (`SettleAfterStroke`). */
export const SAND_LETTERS_SETTLE = liquidSettleEvent('experience.sand-letters.settle', SAND_LETTERS_KIND)

/**
 * Next letter: the tray is replaced by a fresh one holding letter `letter` (with the hint tint
 * `hint`), in one event, so it is one undo step and replays from its numbers alone.
 */
export const SAND_LETTERS_NEXT_EVENT = 'experience.sand-letters.nextLetter' as const

export function nextLetterEvent(letter: number, hint: number): EventTuple {
  return experienceEvent(SAND_LETTERS_NEXT_EVENT, { letter: letterIndex(letter), hint })
}

/** Reducer handlers for Sand letters (`experience.sand-letters.*`). */
export const eventHandlers: Record<string, PageEventHandler> = {
  ...SAND_LETTERS_SETTLE.handlers,
  [SAND_LETTERS_NEXT_EVENT]: (ctx, event) => {
    const p = event[1] as { letter?: unknown; hint?: unknown } | undefined
    if (typeof p?.letter !== 'number' || !Number.isFinite(p.letter)) return
    const hint = typeof p.hint === 'number' && Number.isFinite(p.hint) ? p.hint : 0
    ctx.setBase(new Map(sandLettersWorldCells(p.letter, hint)))
  },
}
